import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { OfflineManagerService } from "./offline-manager.service";
import { Observable, from, of} from "rxjs";
import { environment } from "../../environments/environment";
import { NetworkService, ConnectionStatus } from "./network.service";
import { Storage } from "@ionic/storage-angular";
import { tap, map, catchError } from "rxjs/operators";
import { throwError } from 'rxjs';


const API_STORAGE_KEY = "empresas";

@Injectable({
  providedIn: "root",
})
export class UsuariosService {
  private url: any = environment.url;
  private token: string = "";
  public usuario: any = {
    nome: "Troca Datas",
    email: "",
    sobre: "..",
    avatar: "",
    telefone: "",
  };

  constructor(
    private http: HttpClient,
    private storage: Storage,
    private networkService: NetworkService,
    private offlineManager: OfflineManagerService
  ) {}
  
 


async getUserId(): Promise<number> {
  // Recupera o token do Storage
  await this.storage.get("token").then((valor) => {
    this.token = valor;
  });

  // Realiza a requisição HTTP para obter os dados do usuário
  return this.http
    .get<any>(`${this.url}/usuario`, {
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + this.token,
      },
    })
    .toPromise()
    .then((response) => response.id)
    .catch((error) => {
      console.error("Erro ao obter ID do usuário:", error);
      throw error;
    });
}

  envirCodigo(codigo: string): Observable<boolean> {
    return this.http.post<{ success: boolean }>(`${this.url}/receberCodigoNovoUsuario`, { codigo })
      .pipe(
        map(response => response.success),
        catchError(() => of(false))
      );
  }

  enviarCodigoRecuperarSenha(email: string, codigo: string): Observable<boolean> {
    return this.http.post<{ success: boolean }>(`${this.url}/receberCodigoParaRecuperarSenha`, { email, codigo })
        .pipe(
            map(response => response.success),
            catchError(() => of(false))
        );
  }
  

  confirmarCodigo(email: string, codigo: string): Promise<boolean> {
    return this.http.post<{ success: boolean }>(`${this.url}/confirmarCodigo`, { email, codigo })
      .toPromise()
      .then(response => response.success)
      .catch(() => false);
  }


  get(pagina, tipo = ""): Observable<any[]> {
    if (this.networkService.getCurrentNetworkStatus() == ConnectionStatus.Offline) {
      return from(this.getLocalData("usuarios?pagina=" + pagina));
    } else {
      return this.http
        .get(this.url + "/usuarios?pagina=" + pagina, {
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + this.token,
          },
        })
        .pipe(
          map((res) => res["data"]),
          tap((res) => {
            this.setLocalData("usuarios?pagina=" + pagina, res);
          })
        );
    }
  }

  private setLocalData(key, data) {
    this.storage.set(`${API_STORAGE_KEY}-${key}`, data);
  }

  private getLocalData(key) {
    return this.storage.get(`${API_STORAGE_KEY}-${key}`);
  }

  salvar(dados) {
    return this.http.post(this.url + "/users", dados).toPromise();
  }


    async enviarDadosRecuperacaoSenha(email: string, newPassword: string): Promise<any> {
      try {
        const response = await this.http.post(`${this.url}/dados-recover`, { email, newPassword }).toPromise();
        return response; // Retornando a resposta completa do servidor
      } catch (error) {
        console.error('Erro ao recuperar senha:', error);
        throw error; // Lançando o erro para que o componente possa tratar
      }
    }
     

  login(dados: any) {
    return this.http.post(this.url + "/sessions", dados)
      .pipe(
        tap(response => {
          console.log("Login realizado com sucesso:", response);
        }),
        catchError(error => {
          console.error("Erro ao realizar login:", error);
          return throwError(error);
        })
      );
  }

  async alterarFoto(dados: any): Promise<any> {
    try {
      const response = await this.http.put(this.url + "/fotoPerfil", dados, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }).toPromise();
      console.log("Resposta do servidor:", response);
      return response;
    } catch (error) {
      console.error("Erro ao alterar foto:", error);
      throw error;
    }
  }
  
  

  async getUsuario() {
    try {
      this.token = await this.storage.get("token");
      return await this.http
        .get(this.url + "/dadosUsuario", {
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + this.token,
          },
        })
        .toPromise();
    } catch (error) {
      console.error("Erro ao obter usuário:", error);
      throw error;
    }
  }

  async getUsuarioPorId(id: any) {
    try {
      // Faz a requisição para obter os dados do usuário
      const response = await this.http.get(this.url + "/usuario/" + id).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }
  async getChatSessionData(matchId: number): Promise<any> {
    const url = `${this.url}/chat-session`;
    const payload = { matchId};
    return this.http.post(url, payload).toPromise();
  }
  
  
  
  
  deleteUsuario(): Promise<any> {
    console.log('Enviando requisição DELETE para:', this.url + '/delete-usuario');
    return this.http.delete<any>(this.url + '/delete-usuario')
      .pipe(
        tap(
          response => console.log('Resposta recebida:', response),
          error => console.error('Erro na requisição:', error)
        )
      )
      .toPromise();
  }


  async setToken() {
    await this.storage.get("token").then((valor) => {
      this.token = valor;
    });
  }

  getEmpresa(id): Observable<any[]> {
    if (this.networkService.getCurrentNetworkStatus() == ConnectionStatus.Offline) {
      return from(this.getLocalData("usuario/" + id));
    } else {
      return new Observable<any[]>(observer => {
        this.getLocalData("usuario/" + id)
          .then(data => {
            observer.next(data);
            observer.complete();
          })
          .catch(error => {
            observer.error(error);
          });
      });
    }
  
  }

async getChatSessionDataByDataId(dataId: number): Promise<any> {
  const url = `${this.url}/chat-session-by-data`;
    const payload = { dataId };
      return this.http.post(url, payload).toPromise();
}

async getChatSessionDataByRoom(room: string): Promise<any> {
  const url = `${this.url}/chat-session-by-room`;
  const payload = { room };
  return this.http.post(url, payload).toPromise();
}


   // Método para enviar o token FCM para o backend
async enviarTokenParaBackend(tokenFCM: string): Promise<any> {
  try {
    // Recupera o token de autenticação do Storage
    await this.storage.get("token").then((valor) => {
      this.token = valor;
    });

    // Headers com o token de autenticação
    const headers = {
      Authorization: "Bearer " + this.token,
      "Content-Type": "application/json",
    };

    // Faz a requisição POST para enviar o token FCM para o backend
    const response = await this.http.post(
      `${this.url}/salvar-token-fcm`,
      { token: tokenFCM },
      { headers }
    ).toPromise();

    return response;
  } catch (error) {
    console.error("Erro ao enviar o token FCM:", error);
    throw error;
  }
}

atualizarTermosAceitos(): Observable<any> {
  return this.http.post(`${this.url}/atualizar-termos`, {});
}




}